import callAPI from '../call-api';
import fetch from 'react';
//CallApi is used for Help 
//Dustin M Created this toolkit for ease of access utilities
var toolkit = {
    organizationDetails: {name: ''},
    //this is a configuration to flip debug mode on and off. Logs are suppressed when debugable is false
    'debugable': false,
    //getParam is a work in progress... this works on websites, but apparently not in react
    getParam: function (P_name) {
        /*  var param = decodeURI( (RegExp(P_name + '=' + '(.+?)(&|$)').exec(this.props.location.search)||[,null])[1] ); 
          return param;*/
    },
    //Provide messages for debuggable mode
    log: function (msg) {

        if (window.location.href != null && window.location.href.match("debug=true") != null) {
            let message = 'Toolkit.log: ' + msg;
            console.log(message);
        }
    },
    setStateFilter: function (stateId,stateName) {
        if(stateId==null || stateId === undefined || stateId.length !== 2) return;
        var isMissing = true;
        this.log('entered setStateFilter with id ' + stateId);
        try {
           
            var mySession = JSON.parse(sessionStorage.getItem("engage-settings"));
            this.log('mySession is ' + JSON.stringify(mySession));
            if (mySession == null || mySession === "") {
                mySession = { currentUser: {settings: { stateFilters: [] } }};


            }
           if (mySession.currentUser.settings == null || mySession.currentUser.settings ===undefined|| mySession.currentUser.settings===""){
               mySession.currentUser.settings = {stateFilters:[]};
           }
            this.log('mySession before stateFilter null check is ' + JSON.stringify(mySession));
            if (mySession.currentUser.settings.stateFilters == null || mySession.currentUser.settings.stateFilters === undefined) {
                mySession.currentUser.settings.stateFilters = [];
            }
            this.log('mySession after stateFilter null check is ' + JSON.stringify(mySession));
            //--ensure that the filter has not yet been set
            if(mySession.currentUser.settings.stateFilters.length>0)
            for (var i = 0; i < mySession.currentUser.settings.stateFilters.length; i++) {
                if(mySession.currentUser.settings.stateFilters[i].id === undefined) continue;
                console.log(`evaluating state in filter: ${mySession.currentUser.settings.stateFilters[i].id} of the ${mySession.currentUser.settings.stateFilters.length} states listed.`)
                if (stateId === mySession.currentUser.settings.stateFilters[i].id) {
                    console.log(`found ${stateId} in filter, aka ${stateName}`)
                    isMissing = false;
                }
            }
            if (isMissing) {
                mySession.currentUser.settings.stateFilters.push({ name: stateName, id: stateId });

                this.log("mySession updated to " + JSON.stringify(mySession));
                sessionStorage.setItem('engage-settings', JSON.stringify(mySession));
                if(mySession.currentUser.hasEventReload === undefined || mySession.currentUser.hasEventReload !== true){
                    mySession.currentUser.hasEventReload = true;
                    sessionStorage.setItem('engage-settings', JSON.stringify(mySession));
                    window.location.reload();

                };
                mySession.currentUser.hasEventReload = false;
            }

        } catch (e) {
            this.log('Error in setStateFilter: ' + e.message);
        }
        this.log('set state filter');

    },
    getCussHost() {
        // explicit override for local dev - e.g. REACT_APP_CUSS_HOST=https://customers-qa.nfib.org/
        // set in .env.local, so localhost can be pointed at any environment's
        // customers API without changing the hostname-based defaults below
        if (process.env.REACT_APP_CUSS_HOST) {
            var overrideUrl = process.env.REACT_APP_CUSS_HOST;
            if (overrideUrl.slice(-1) !== '/') {
                overrideUrl += '/';
            }
            this.log('Using REACT_APP_CUSS_HOST override: ' + overrideUrl);
            return overrideUrl;
        }
        var myEnvironment = window.location.href;
        this.log('Located at ' + myEnvironment);
        var url = 'https://customers.nfib.org/';
        if (myEnvironment.match('ua.nfib.org') != null) {
            url = 'https://customers-ua.nfib.org/';
        } else if (myEnvironment.match('dv.nfib.org') != null || myEnvironment.match('localhost') != null) {
            url = 'https://customers-dv.nfib.org/';
        } else if (myEnvironment.match('qa.nfib.org') != null) {
            url = 'https://customers-qa.nfib.org/';
        } else {
            url = '/';
        }
        this.log('Detected cussHost to use as ' + url);
        return url;
    },
    //Add the business address to the filter for events
    applyBizAddressToFilter: function (orgKey) {
        this.log('entered applyBizAddressToFilter(' + orgKey + ')');
        fetch(toolkit.getCussHost() + 'api/organization/' + orgKey,
            {
                method: 'GET',
                //src: https://github.com/webpack/webpack-dev-server/issues/533
                mode: 'no-cors',
                headers: {
                    'NFIBAppID': 'D1E4D5F5-704F-4091-8FA4-5D0B848B493D',
                    'Connection': 'keep-alive',
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            }
        )
            .then(data => {
                if (data.json && data.resp && data.resp.ok) {
                    if (data != null && data.addresses != null) {
                        this.log('Retrieved state ' + data.addresses.stateCode);
                        toolkit.setStateFilter(data.addresses.stateCode);
                        toolkit.organizationDetails = data.organizationDetails;
                        this.log('toolkit.organizationDetails is now '+toolkit.organizationDetails);
                    }
                }
            }
            )

    }
    ,
    //The below function will apply the personal Address to state filter. If found, it will also apply the business address to filter.
    applyPersonalPlusBizAddressToFilter: function () {
        this.log('entered applyPersonalPlusBizAddressToFilter()');
        
        //retrieve the email address from settings
        try {
            var mySession = JSON.parse(sessionStorage.getItem("engage-settings"));
            if (mySession == null || mySession.currentUser == null || mySession.currentUser === "" || mySession.currentUser.id == null || mySession.currentUser.id === "") {
                this.log('No email, nor user was found. Will not request details.');
                return;
            }
            var email = mySession.currentUser.settings.email;
            this.log('email is ' + email);
            var destinationUrl = '';

            if (email == null || email === "" || email === "undefined") {

                this.log(JSON.stringify(mySession));

                destinationUrl =
                    '/api/cuss/2.0/individuals/' + mySession.currentUser.id;
            } else {
                destinationUrl = '/api/cuss/2.0/individuals?email=' + email;
            }
            return callAPI(destinationUrl + '').then(data => {
                if (data.json && data.resp && data.resp.ok) {
                    if (data != null && data.personalAddress != null) {
                        this.log('Retrieved state ' + data.personalAddress.stateCode);
                        toolkit.setStateFilter(data.personalAddress.stateCode);
                        if (data.orgKey != null) {
                            toolkit.applyBizAddressToFilter(data.orgKey);
                        }
                    }
                } else {
                    fetch(toolkit.getCussHost() + destinationUrl,
                        {
                            method: 'GET',
                            //src: https://github.com/webpack/webpack-dev-server/issues/533
                            mode: 'no-cors',
                            headers: {
                                'NFIBAppID': 'D1E4D5F5-704F-4091-8FA4-5D0B848B493D',
                                'Connection': 'keep-alive',
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                        }
                    )
                        .then(function (data2) {
                            this.log(data2);
                            if (data2 != null && data2.personalAddress != null) {
                                toolkit.log('Retrieved state ' + data2.personalAddress.stateCode);
                                toolkit.setStateFilter(data2.personalAddress.stateCode);
                                if (data2.orgKey != null) {
                                    toolkit.applyBizAddressToFilter(data2.orgKey);
                                }
                            }
                        });
                }

            }

            )
                .catch(err => {
                    this.log('CallApi Error ' + err.message);
                });



        } catch (Exception) {
            this.log('Ex: ' + Exception.message);
        }
    }
}

export default toolkit;


// WEBPACK FOOTER //
// ./src/common/utils/toolkit.js